/* Read-only catalog service. Never writes products or prices. */
(() => {
  if (window.JcCatalog) return;
  let pending;
  const root = window.Shopify?.routes?.root || '/';
  async function load() {
    if (pending) return pending;
    pending = (async () => {
      const products = new Map();
      let page = 1, pages = 1;
      do {
        const url = new URL(root + 'collections/all', location.origin);
        url.searchParams.set('view', 'jc-discovery');
        url.searchParams.set('page', String(page));
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw Error('The collection could not be loaded. Please try again.');
        const data = await response.json();
        if (!Array.isArray(data.products) || !Number.isInteger(data.pages)) throw Error('Collection unavailable. Please use Shop all.');
        data.products.forEach(p => { if (p.handle && p.url) products.set(p.handle, p); });
        pages = data.pages;
        page += 1;
      } while (page <= pages);
      return Array.from(products.values());
    })().catch(error => { pending = null; throw error; });
    return pending;
  }
  function readSaved() {
    try {
      const value = JSON.parse(localStorage.getItem('jc-saved-pieces') || '[]');
      return Array.isArray(value) ? value.filter(v => typeof v === 'string') : [];
    } catch { return []; }
  }
  let saved = new Set(readSaved());
  let compared = new Set();
  function update() {
    try { localStorage.setItem('jc-saved-pieces', JSON.stringify([...saved])); } catch { /* session memory remains usable */ }
    document.dispatchEvent(new CustomEvent('jc:selection', { detail: { saved: [...saved], compared: [...compared] } }));
  }
  window.JcCatalog = {
    load,
    get saved() { return [...saved]; },
    get compared() { return [...compared]; },
    toggleSaved(handle) { saved.has(handle) ? saved.delete(handle) : saved.add(handle); update(); },
    toggleCompared(handle) {
      if (compared.has(handle)) compared.delete(handle);
      else if (compared.size < 2) compared.add(handle);
      else return false;
      update(); return true;
    },
    filter(products, { category = 'all', material = 'all', budget = 'all', query = '' } = {}) {
      const limit = budget === 'all' ? Infinity : Number(budget) * 100;
      const terms = query.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
      return products.filter(p => p.available && (category === 'all' || p.category === category) && (material === 'all' || p.material === material) && p.price <= limit && terms.every(t => p.title.toLocaleLowerCase().includes(t)));
    }
  };
})();
